var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #037a9a;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.81,34H11.58c-2.31,0-4.19-1.88-4.19-4.19V11.58c0-2.31,1.88-4.19,4.19-4.19h18.23c2.31,0,4.19,1.88,4.19,4.19v18.23c0,2.31-1.88,4.19-4.19,4.19ZM11.58,9.38c-1.21,0-2.19.98-2.19,2.19v18.23c0,1.21.98,2.19,2.19,2.19h18.23c1.21,0,2.19-.98,2.19-2.19V11.58c0-1.21-.98-2.19-2.19-2.19H11.58Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.93,26.62c-2.72,0-4.93-2.21-4.93-4.93V4.93C0,2.21,2.21,0,4.93,0h16.76c2.72,0,4.93,2.21,4.93,4.93h-2c0-1.61-1.31-2.93-2.93-2.93H4.93c-1.61,0-2.93,1.31-2.93,2.93v16.76c0,1.61,1.31,2.93,2.93,2.93v2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.f0901c48e59dfe1d1ec355310ef3ecd5.svg";
export { ForwardRef as ReactComponent };